export const APP_NAME = "homepage-web";
export const CSRF_TOKEN_COOKIE_NAME = "CSRF-TOKEN";
export const SHARED_ASSETS_PATH = `frontend-web`;
export const FULL_SHARED_ASSETS_PATH = `${SHARED_ASSETS_PATH}/_${APP_NAME}/assets`;
export const FULL_SHARED_STATIC_PATH = `${SHARED_ASSETS_PATH}/_${APP_NAME}/static`;

export const CMP_LEG_INT_VARIATIONS = {
  A: "0", // control
  B: "1", // variation
};

export const CMP_EQUAL_CHOICE_VARIATIONS = {
  A: "0", // bots
  B: "1", // variant 1
  C: "2", // variant 2
  D: "3", // variant 3
  E: "4", // control
  F: "5", // default
};
